import { Injectable } from '@angular/core';

export type AppFont = 'montserrat' | 'poppins' | 'system';
export type AppTheme = 'light' | 'dark';

const FONT_KEY = 'app_font';
/** Same key as the template's Setting Panel */
const THEME_KEY = 'theme';
const FONT_CLASSES: AppFont[] = ['montserrat', 'poppins', 'system'];

@Injectable({ providedIn: 'root' })
export class ThemeService {
  get font(): AppFont {
    return (localStorage.getItem(FONT_KEY) as AppFont) || 'montserrat';
  }

  get theme(): AppTheme {
    return (localStorage.getItem(THEME_KEY) as AppTheme) || 'light';
  }

  setFont(font: AppFont) {
    localStorage.setItem(FONT_KEY, font);
    this.applyFont(font);
  }

  /**
   * Uses the same body classes as the template's Setting Panel:
   * body.dark / body.light — so both systems stay in sync.
   */
  setTheme(theme: AppTheme) {
    localStorage.setItem(THEME_KEY, theme);
    this.applyTheme(theme);
  }

  /** Restore preferences from localStorage — call once on app start */
  apply() {
    this.applyFont(this.font);
    this.applyTheme(this.theme);
  }

  private applyFont(font: AppFont) {
    FONT_CLASSES.forEach(f => document.body.classList.remove('font-' + f));
    document.body.classList.add('font-' + font);
  }

  private applyTheme(theme: AppTheme) {
    document.body.classList.remove('dark', 'light');
    document.body.classList.add(theme); // 'dark' or 'light' — same as template
  }
}
